const ApiKey = 'JOB45689ASD9857ASDSCRIPT';

export default ApiKey;
